import { render, staticRenderFns } from "./LoaderApp.vue?vue&type=template&id=fe1ef072&scoped=true&"
import script from "./LoaderApp.vue?vue&type=script&lang=js&"
export * from "./LoaderApp.vue?vue&type=script&lang=js&"
import style0 from "./LoaderApp.vue?vue&type=style&index=0&id=fe1ef072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1ef072",
  null
  
)

export default component.exports